import React, { useContext } from "react";
import { Container } from "@mui/material";
import { Alert, MantineColor } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

import { Colors } from "../../Lib/data";
import { AppContext } from "../../Pages/Dashboard";

interface DisplayAlertProps {
  containerSize?: "xs" | "sm" | "md" | "lg" | "xl";
  containerStyle?: React.CSSProperties;
  Icon?: typeof IconInfoCircle;
  color?: MantineColor;
  children: React.ReactNode;
  title?: string;
}
export default function DisplayAlert({
  containerSize = "sm",
  containerStyle,
  color,
  Icon = IconInfoCircle,
  children,
  title = "Alert!",
}: DisplayAlertProps) {
  return (
    <Container maxWidth={containerSize} style={containerStyle}>
      <Alert title={title} icon={<Icon />}>
        {children}
      </Alert>
    </Container>
  );
}
